/**
 * Operator-declared media acquisition Source (UI label: "Source").
 * Must stay in sync with admin-api media-source.js allowlists.
 */
export const MEDIA_SOURCE_OPTIONS = [
  "iTunes",
  "CD",
  "DMP",
  "SKS-S",
  "SKS-C",
] as const;

export type MediaSource = (typeof MEDIA_SOURCE_OPTIONS)[number];

export function isMediaSource(value: string | null | undefined): value is MediaSource {
  return (
    typeof value === "string" &&
    (MEDIA_SOURCE_OPTIONS as readonly string[]).includes(value)
  );
}
